import { Channel, ProductType } from "@/api_client";
import { matchProductType } from "@/utils/productUtils";

export const AgpId = {
  Householder: 90,
  Travel: 91,
  Baby: 94,
  Child: 96,
  Cat: 99,
  Dog: 100,
};
export type AgpId = (typeof AgpId)[keyof typeof AgpId];

export const NordeaAgpId = {
  Householder: 127,
  Travel: 135,
  Baby: 115,
  Child: 122,
  Cat: 121,
  Dog: 125,
};
export type NordeaAgpId = (typeof NordeaAgpId)[keyof typeof NordeaAgpId];

export const getAgpId = (
  productType?: ProductType | null,
  channel?: Channel | null,
): AgpId | NordeaAgpId => {
  if (channel === Channel.NORDEA) {
    return GetNordeaAgpId(productType);
  }

  return GetWebshopAgpId(productType);
};

const webshopAgpIdMap: Record<ProductType | "", AgpId> = {
  [ProductType.HOUSEHOLDER]: AgpId.Householder,
  [ProductType.TRAVEL]: AgpId.Travel,
  [ProductType.BABY]: AgpId.Baby,
  [ProductType.CAR]: -1, // Placeholder, should not be used
  [ProductType.INCOME]: -1, // Placeholder, should not be used
  [ProductType.SPORT]: -1, // Placeholder, should not be used
  [ProductType.CHILD]: AgpId.Child,
  [ProductType.VAN]: -1, // Placeholder, should not be used
  [ProductType.CAT]: AgpId.Cat,
  [ProductType.DOG]: AgpId.Dog,
  "": -1, // Fallback for undefined product type
};

const nordeaAgpIdMap: Record<ProductType | "", NordeaAgpId> = {
  [ProductType.HOUSEHOLDER]: NordeaAgpId.Householder,
  [ProductType.TRAVEL]: NordeaAgpId.Travel,
  [ProductType.BABY]: NordeaAgpId.Baby,
  [ProductType.CAR]: -1, // Placeholder, should not be used
  [ProductType.INCOME]: -1, // Placeholder, should not be used
  [ProductType.SPORT]: -1, // Placeholder, should not be used
  [ProductType.CHILD]: NordeaAgpId.Child,
  [ProductType.VAN]: -1, // Placeholder, should not be used
  [ProductType.CAT]: NordeaAgpId.Cat,
  [ProductType.DOG]: NordeaAgpId.Dog,
  "": -1, // Fallback for undefined product type
};

export const agpIdToChannelMap: Record<AgpId | NordeaAgpId, Channel> = {
  [AgpId.Householder]: Channel.WEB_SHOP,
  [AgpId.Travel]: Channel.WEB_SHOP,
  [AgpId.Baby]: Channel.WEB_SHOP,
  [AgpId.Child]: Channel.WEB_SHOP,
  [AgpId.Cat]: Channel.WEB_SHOP,
  [AgpId.Dog]: Channel.WEB_SHOP,
  [NordeaAgpId.Householder]: Channel.NORDEA,
  [NordeaAgpId.Travel]: Channel.NORDEA,
  [NordeaAgpId.Baby]: Channel.NORDEA,
  [NordeaAgpId.Child]: Channel.NORDEA,
  [NordeaAgpId.Cat]: Channel.NORDEA,
  [NordeaAgpId.Dog]: Channel.NORDEA,
};

function GetWebshopAgpId(productType?: ProductType | null): AgpId {
  return matchProductType(productType, webshopAgpIdMap);
}

function GetNordeaAgpId(productType?: ProductType | null): NordeaAgpId {
  return matchProductType(productType, nordeaAgpIdMap);
}
